import type * as Item from "../../lib/models/item.server.ts"

import * as React from "react"
import * as ItemsGrid from "../../lib/ui/items-grid.tsx"
import * as Query from "../../lib/utils/query.ts"

import { useLang } from "../../lib/lang/use-lang.ts"

type Props = {
  orderOptions: Item.OrderOptions
}

export const ItemsOrder = ({ orderOptions: orderOptionsProp }: Props) => {
  const lang = useLang()

  const orderOptions = React.useMemo(() => {
    return orderOptionsProp.options.map((orderOption) => ({
      id: orderOption,
      value: getOrderLabel(orderOption),
    }))
  }, [orderOptionsProp, lang])

  function getOrderLabel(orderOption: Item.OrderBy) {
    switch (orderOption) {
      case "recent":
        return lang.terms.RECENT
      case "most-taps":
        return lang.terms.MOST_TAPS
      case "price-asc":
        return `${lang.terms.PRICE}: ${lang.terms.LOW_TO_HIGH}`
      case "price-desc":
        return `${lang.terms.PRICE}: ${lang.terms.HIGH_TO_LOW}`
      default: {
        const _exhaustiveCheck: never = orderOption
        return _exhaustiveCheck
      }
    }
  }

  return (
    <ItemsGrid.ItemsOrder
      of={orderOptions}
      defaultValue={orderOptionsProp.default}
      queryParam={Query.ORDER_BY_PARAM}
      label={lang.terms.SORT_BY}
    />
  )
}
